import { useAuthStore } from '@store/authStore';

/**
 * Custom hook for authentication
 * Wraps authStore for easier use in components
 */
export const useAuth = () => {
    const { user, token, isAuthenticated, loading, login, logout, checkAuth, register } = useAuthStore();

    return {
        user,
        token,
        isAuthenticated,
        loading,
        login,
        logout,
        checkAuth,
        register,
        isLoggedIn: isAuthenticated && !!user && !!token,
    };
};

export default useAuth;
